import { provideHttpClient, withInterceptors, withInterceptorsFromDi, withJsonpSupport } from "@angular/common/http";
import { ApplicationConfig, provideZoneChangeDetection } from "@angular/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideRouter } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { providePrimeNG } from "primeng/config";
import { routes } from "./app.routing";
import { ComunGatewayAbstract } from "./domain/model/comun/gateway/comun-gateway.abstract";
import { FirebaseGatewayAbstract } from "./domain/model/firebase/gateway/auth-farebase.abstract";
import { MaestrosGateway } from "./domain/model/maestro/gateway/maestros-gateway";
import { InformesNhGateway } from "./domain/model/no-hospitalario/informes/gateway/informes-nh-gateway";
import { PagosGateway } from "./domain/model/no-hospitalario/pagos/gateway/pagos-gateway";
import { SolicitudNhGateway } from "./domain/model/no-hospitalario/solicitud/gateway/solicitud-nh-gateway";
import { RemisionGatewayAbstract } from "./domain/model/remision/gateway/remision-gateway.abstract";
import { SeguridadGateway } from "./domain/model/seguridad/gateway/seguridad-gateway";
import { UbicacionGateway } from "./domain/model/ubicacion/gateway/ubicacion-gateway";
import { ComunServiceI } from "./infraestructure/comun/comun-api.service";
import { FirebaseAuthenticationService } from "./infraestructure/firebase/firebase-auth.service";
import { MaestrosApiService } from "./infraestructure/maestros/maestros-api.service";
import { InformesNhService } from "./infraestructure/no-hospitalario/informes/informes-nh-api.service";
import { PagosService } from "./infraestructure/no-hospitalario/pagos/pagos-api.service";
import { SolicitudNhService } from "./infraestructure/no-hospitalario/solicitud/solicitud-nh.service";
import { RemisionService } from "./infraestructure/remision/remision-api.service";
import { SeguridadService } from "./infraestructure/seguridad/seguridad.service";
import { UbicacionService } from "./infraestructure/ubicacion/ubicacion.service";
import {httpHandlerInterceptor} from "./shared/interceptors/error-handler.interceptor";
import {apiResponseNormalizerInterceptor} from "./shared/interceptors/api-response-normalizer.interceptor";
import MyPreset from "./preset";
import { firebaseConfig } from "./shared/firebase/firebase.config";



export const appConfig: ApplicationConfig = {
    providers: [
        provideHttpClient(
            withInterceptorsFromDi(),
            withJsonpSupport(),
            // El orden importa: en la respuesta los interceptores se ejecutan al reves,
            // asi que el normalizador corre primero y el HttpErrorResponse que emite
            // ante un error de negocio queda dentro del catchError de httpHandlerInterceptor.
            withInterceptors([httpHandlerInterceptor, apiResponseNormalizerInterceptor])
        ),
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: MyPreset,
                options: {
                    prefix: 'p',
                    darkModeSelector: false || 'none',
                    cssLayer: false,
                }
            },
            translation: {
                monthNames: [
                    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
                ],
                monthNamesShort: [
                    'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
                    'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
                ],
                dayNames: [
                    'Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'
                ],
                dayNamesShort: [
                    'dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'
                ],
                dayNamesMin: [
                    'D', 'L', 'M', 'X', 'J', 'V', 'S'
                ],
                today: 'Hoy',
                clear: 'Borrar'
            }
        }),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        MessageService,
        ConfirmationService,
        { provide: MaestrosGateway, useClass: MaestrosApiService },
        { provide: SolicitudNhGateway, useClass: SolicitudNhService },
        { provide: ComunGatewayAbstract, useClass: ComunServiceI },
        { provide: RemisionGatewayAbstract, useClass: RemisionService },
        { provide: InformesNhGateway, useClass: InformesNhService },
        { provide: PagosGateway, useClass: PagosService },
        { provide: SeguridadGateway, useClass: SeguridadService },
        { provide: UbicacionGateway, useClass: UbicacionService },
        { provide: FirebaseGatewayAbstract, useClass: FirebaseAuthenticationService },
        ...firebaseConfig,
    ]
};
